import type { UserData } from "@services/api/authentication/currentUser/interface";
import { httpClient } from "@services/api/httpClient";

export async function getCurrentUser(): Promise<UserData | null> {
  const response = await httpClient.get<any>("/auth/me");
  return response.data?.data || null;
}